import { Component } from '@angular/core';

import { SessionService } from '../../services/session.service';
import { AdminService } from '../../services/admin.service';
import { RegionService } from '../../services/region.service';

@Component({
  selector: 'output-pdf',
  templateUrl: './pdf.html'
})
export class PDFComponent {

  constructor(
    public regionService: RegionService,
    public sessionService: SessionService,
    public adminService: AdminService
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/components/pdf/pdf.component.ts